import React, { useState, useRef } from "react";
import styles from "./info-icon-popover.module.scss";
import { useClickOutsideListener } from "@src/hooks/use-click-outside-listener";
import { GradientBorderContainer } from "@components/templates/layouts/gradient-border-container/gradient-border-container";
import { InfoIconButtonWrapperWithTooltip } from "@src/components/molecules/info-icon-button-wrapper-with-tooltip/info-icon-button-wrapper-with-tooltip";
import { CustomerNamespaceStringNav } from "@src/components/atoms/customer-namespace-string-nav/customer-namespace-string-nav";
import { VersionStringInfoNav } from "@src/components/atoms/version-string-info-nav/version-string-info-nav";
import { TimezoneStringInfoNav } from "@src/components/atoms/timezone-string-info-nav/timezone-string-info-nav";
import { CopyAccessTokenLinkNav } from "@src/components/atoms/copy-access-token-link-nav/copy-access-token-link-nav";
import { RenderUnreleasedFeaturesInfoNav } from "@src/components/atoms/render-unreleased-features-info-nav/render-unreleased-features-info-nav";
import { RenderOnlyForDevelopersInfoNav } from "@src/components/atoms/render-only-for-developers-info-nav/render-only-for-developers-info-nav";

const cssClassName = "info-icon-with-popover";

export const InfoIconWithPopover = () => {
  const popoverRef = useRef();
  const [isInfoPopoverOpen, setIsInfoPopoverOpen] = useState(false);
  const [isInfoIconActive, setIsInfoIconActive] = useState(false);
  const tooltipPosition = "top";

  const handleClick = () => {
    const toggle = (prev) => !prev;
    setIsInfoPopoverOpen(toggle);
    setIsInfoIconActive(toggle);
  };

  useClickOutsideListener(popoverRef, handleClick, isInfoPopoverOpen);

  return (
    <span className={styles[cssClassName]}>
      <InfoIconButtonWrapperWithTooltip
        isInfoIconActive={isInfoIconActive}
        handleClick={handleClick}
      />
      {isInfoPopoverOpen && (
        <div className={styles[`${cssClassName}__popover-wrapper`]}>
          <GradientBorderContainer>
            <div
              ref={popoverRef}
              className={styles[`${cssClassName}__popover`]}
            >
              <CustomerNamespaceStringNav tooltipPosition={tooltipPosition} />

              <VersionStringInfoNav tooltipPosition={tooltipPosition} />

              <TimezoneStringInfoNav tooltipPosition={tooltipPosition} />

              <CopyAccessTokenLinkNav tooltipPosition={tooltipPosition} />

              <RenderUnreleasedFeaturesInfoNav
                tooltipPosition={tooltipPosition}
              />

              <RenderOnlyForDevelopersInfoNav
                tooltipPosition={tooltipPosition}
              />
            </div>
          </GradientBorderContainer>
        </div>
      )}
    </span>
  );
};
